







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { GeneratedRecommendationLetterItem } from '@/models/student/recommendation-letter';
import { recommendationLetterModule } from '@/store/modules/entities/recommendation-letter.module';

@Component
export default class GStudentRecordRecommendationLetterEdit extends Vue {
  @Prop({ required: false }) selectedLetter?: GeneratedRecommendationLetterItem | null;
  private localTitle: string = '';
  private localContent: string = '';
  private originalTitle: string = '';
  private originalContent: string = '';

  @Watch('selectedLetter', { immediate: true })
  onSelectedLetterChange(newLetter: GeneratedRecommendationLetterItem | null) {
    if (newLetter) {
      this.originalTitle = newLetter.title || '';
      this.originalContent = newLetter.content || '';
      this.localTitle = this.originalTitle;
      this.localContent = this.originalContent;
    } else {
      this.resetLocal();
    }
  }

  get hasChanges(): boolean {
    return this.localTitle !== this.originalTitle || this.localContent !== this.originalContent;
  }

  get rowCount(): number {
    return Math.max(10, this.localContent.split('\n').length);
  }

  get titleValidationError(): boolean {
    return !this.localTitle || this.localTitle.trim().length < 1;
  }

  get contentValidationError(): boolean {
    return !this.localContent || this.localContent.trim().length < 1;
  }

  get isValidInput(): boolean {
    // タイトルが1文字以上かチェック（空白文字を除く）
    const isTitleValid = this.localTitle && this.localTitle.trim().length >= 1;
    // 本文が1文字以上かチェック（空白文字を除く）
    const isContentValid = this.localContent && this.localContent.trim().length >= 1;
    // タイトルと本文の両方が有効な場合のみtrue
    return isTitleValid && isContentValid;
  }

  get hasValidationErrors(): boolean {
    return !this.isValidInput;
  }

  resetLocal() {
    this.localTitle = '';
    this.localContent = '';
    this.originalTitle = '';
    this.originalContent = '';
  }

  handleCancelEdit() {
    if (this.hasChanges) {
      this.$Modal.confirm({
        title: this.$t('RECOMMENDATION_LETTER_UNSAVED_CHANGES').toString(),
        content: this.$t('RECOMMENDATION_LETTER_UNSAVED_CHANGES_CONTENT').toString(),
        okText: this.$t('DO_CANCEL').toString(),
        cancelText: this.$t('RETURN').toString(),
        onOk: () => {
          this.resetToOriginal();
          this.$emit('cancel');
        },
      });
    } else {
      this.$emit('cancel');
    }
  }

  resetToOriginal() {
    this.localTitle = this.originalTitle;
    this.localContent = this.originalContent;
  }

  async handleUpdate() {
    if (!this.selectedLetter) return;

    if (!this.isValidInput) {
      this.$Message.error(this.$t('PLEASE_ENTER_REQUIRED_FIELDS') || '必須項目を入力してください');
      return;
    }

    this.$Modal.confirm({
      title: this.$t('UPDATE_CONFIRMATION').toString(),
      content: this.$t('RECOMMENDATION_LETTER_UPDATE_CONFIRM').toString(),
      onOk: async () => {
        try {
          await recommendationLetterModule.updateRecommendationLetter({
            id: this.selectedLetter!.id,
            title: this.localTitle,
            content: this.localContent,
          });
          this.$Message.success(this.$t('RECOMMENDATION_LETTER_UPDATE_SUCCESS'));
          this.originalTitle = this.localTitle;
          this.originalContent = this.localContent;
          this.$emit('cancel');
        } catch (error) {
          this.$Message.error(this.$t('RECOMMENDATION_LETTER_UPDATE_ERROR'));
        }
      },
    });
  }

  mounted() {
    this.adjustTextareaStyle();
  }

  adjustTextareaStyle(): void {
    this.$nextTick(() => {
      // 通常のInputフィールド（単行）
      const inputFields = document.querySelectorAll('.ivu-input-wrapper input, .ivu-input input');
      inputFields.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.borderRadius = '4px';
          el.style.padding = '12px 16px';
          el.style.lineHeight = '1.5';
          el.style.minHeight = '40px';
          el.style.boxSizing = 'border-box';
        }
      });

      // Textareaフィールド（複数行）
      const textareaFields = document.querySelectorAll('.ivu-input-wrapper textarea, .ivu-input textarea');
      textareaFields.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.borderRadius = '4px';
          el.style.resize = 'none';
          el.style.padding = '12px 16px';
          el.style.lineHeight = '1.5';
          el.style.boxSizing = 'border-box';
        }
      });
    });
  }
}
